module.exports = __webpack_public_path__ + "8489ee51e71f5e1e916470d5eb5a56b1.pdf";